import ApplicationController from '../application_controller.js'
import { isNumber, parseString } from '../../commons.js'

export default class ClientController extends ApplicationController {

  static targets = [
    "sharePercentage"
  ]

  //
  // Affiche les champs spécifiques à un type de client
  // la type à afficher est dans l'attribut data-group du dropdown
  // les champs à afficher ont pour classe .hiddable et pour data attributs 'group' et 'group-value'
  //
  selectType(e) {
    this.element.querySelectorAll(".hiddable").forEach(element => {
      element.style.display = 'none';
    })
    this.element.querySelectorAll(`.hiddable[data-group="${e.target.dataset.group}"][data-group-value="${e.target.value}"]`).forEach(element => {
      element.style.display = 'block';
    })
  }

  //
  // Ajout d'un enregistrement nested_form dans une table
  //  data-target : élément du dom
  //  data-fields : formulaire
  //
  add_nested_record(e) {
    e.preventDefault()
    var new_fields = e.target.dataset.fields
    new_fields = new_fields.replace(new RegExp('NESTED_DYNAMIC_FORM', 'g'), performance.now().toString().replace('.', ''))
    e.target.closest('form').querySelector(e.target.dataset.target).insertAdjacentHTML('beforeend', new_fields)
  }

  remove_nested_record(e) {
    e.preventDefault()
    var parent = e.target.closest('tr')
    parent.querySelector("[name*='_destroy']").value = "1"
    parent.style.display = 'none'
  }

  selectUserLines() {
    return this.element.querySelectorAll("#client_users td[data-user-inputs='true']")
  }

  clearUserRates() {
    const lines = this.selectUserLines()
    lines.forEach((line) => {
      line.querySelector("input[type=text]").value = ""
    })
  }

  sharePercentageChanged(e) {
    if (isNumber(parseString(e.target.value))) {
      const percentage = parseString(this.sharePercentageTarget.value) / 100
      this.computeRates(percentage)
    } else {
      this.clearUserRates()
    }
  }

  computeRates(percentage) {
    const lines = this.selectUserLines()
    lines.forEach((line) => {
      const user_rate = parseFloat(line.querySelector("[name=user_rate]").value)
      const to_apply = user_rate - (user_rate * percentage)
      if (to_apply < 0) {
        line.querySelector("input[type=text]").value = ""
      } else {
        line.querySelector("input[type=text]").value = Math.ceil(to_apply)
      }
    })
  }

}